/* eslint-disable no-nested-ternary */
import React from 'react';

const Title = (props) => {
  return (
    <>
      <h1 className="title">{
      props.userType === 1
        ? 'On Campus Survey'
        : props.userType === 2
          ? 'Off Campus Survey'
          : `Welcome to DartMate, ${props.name}!`
      }
      </h1>
      <h3 className="subtitle">{props.subtitle}</h3>
    </>
  );
};

export default Title;
